module.exports = __webpack_public_path__ + "img/m1-screenshot-01_t.83986afc.jpg";